import { hubletApi, resolveApi } from 'hub-http/middlewares/core';
export const getAvatarUrl = (avatarHash, query = {}, avatarSize = 216) => {
  return `https://${resolveApi(hubletApi('app', 'hubspot'))}/hubsettings/v1/avatar/hash/${avatarHash}/${avatarSize}?${new URLSearchParams(query)}`;
};